import { NAV_LINKS } from "@/lib/data";

export const Footer = ({ onBook }) => (
  <footer data-testid="site-footer" className="bg-bone border-t border-[#EAE6E1] pt-20 pb-10">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid md:grid-cols-12 gap-12 pb-16">
        <div className="md:col-span-6">
          <div className="flex items-baseline gap-[2px]">
            <span className="font-serif text-3xl tracking-[0.35em] text-[var(--astera-char)]">ASTERA</span>
            <span className="text-clay text-xl">✳</span>
          </div>
          <p className="mt-6 max-w-sm text-[var(--astera-char)]/60 leading-relaxed">
            Compassionate, expert care for perimenopause, menopause, hormone health
            and sexual wellness — for every season of womanhood.
          </p>
          <button
            onClick={onBook}
            data-testid="footer-book-button"
            className="mt-8 inline-flex items-center rounded-full bg-clay px-7 py-3.5 text-xs uppercase tracking-[0.16em] text-[var(--astera-bone)] transition-colors duration-300 hover:bg-[var(--astera-char)]"
          >
            Book Appointment
          </button>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--astera-char)]/40">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="link-underline text-[var(--astera-char)]/70 hover:text-[var(--astera-char)]">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--astera-char)]/40">Visit</p>
          <ul className="mt-5 space-y-3 text-[var(--astera-char)]/70 text-sm leading-relaxed">
            <li>7982 Yonge St</li>
            <li>Innisfil, ON L9S 1L5</li>
            <li>(249) 388-2997</li>
            <li>hello@asterawomenshealth.ca</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#EAE6E1] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-[var(--astera-char)]/45">
          © {new Date().getFullYear()} ASTERA Women's Health. All rights reserved.
        </p>
        <p className="text-xs text-[var(--astera-char)]/45">
          This site is for information and does not replace medical advice.
        </p>
      </div>
    </div>
  </footer>
);
